// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "roamingredirect-frontend/static/js/" + (chunkId === 616 ? "RoamingRedirect" : chunkId) + "." + {"616":"cac52a010269a94dcb4e","804":"c90c28f42e9c8cc2bfbb"}[chunkId] + ".chunk.js";
};